import { Injectable } from "@angular/core";
import { CONFIGURATION } from "../../../app.constants";
import { USERHOMECONSTANTS } from "../../../modules/userHome";
import { AccountApplicationClaim, ApplicationAccessWorkflow, ApplicationClaim } from "../../../models";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "../../../services/shared";

@Injectable()
export class ApplicationAccessWorkflowService {

    constructor(private httpData: HttpDataService) { }

    public getApplicationAccessWorkflowByTaskId(taskId: string, taskType: string): Observable<ApplicationAccessWorkflow[]> {
        let filter = `$filter=TaskId eq ${taskId} and StatusCode eq '${USERHOMECONSTANTS.organisationApplicationClaimStatusTypes.pending}'`;
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}applicationaccessworkflow/search?${filter}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <ApplicationAccessWorkflow[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public getAccountOrganisationApplicationClaimById(id: string): Observable<AccountApplicationClaim> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}account/GetAccountOrganisationApplicationClaimById?id=${id}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <AccountApplicationClaim>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public getApplicationClaims(id: string): Observable<ApplicationClaim[]> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}application/GetApplicationClaims/${id}`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <ApplicationClaim[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public submitApplicationAccessWorkflow(applicationAccessWorkflow: ApplicationAccessWorkflow): Observable<boolean> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}applicationAccessWorkflow`;

        return Observable.create((observer) => {
            this.httpData.post(dataUrl, JSON.stringify(applicationAccessWorkflow))
                .map(response => <boolean>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/workflow/applicationAccess/applicationAccessWorkflow.service.ts